// Authentication utilities

// Get stored user from localStorage
export const getStoredUser = () => {
  try {
    const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error('Error getting stored user:', error);
    return null;
  }
};

// Store user in localStorage or sessionStorage
export const storeUser = (user, remember = true) => {
  try {
    const userStr = JSON.stringify(user);
    if (remember) {
      localStorage.setItem('user', userStr);
      sessionStorage.removeItem('user'); // Clear from session storage
    } else {
      sessionStorage.setItem('user', userStr);
      localStorage.removeItem('user'); // Clear from local storage
    }
  } catch (error) {
    console.error('Error storing user:', error);
  }
};

// Get authentication token
export const getToken = () => {
  return localStorage.getItem('token') || sessionStorage.getItem('token');
};

// Store authentication token
export const storeToken = (token, remember = true) => {
  if (remember) {
    localStorage.setItem('token', token);
  } else {
    sessionStorage.setItem('token', token);
  }
};

// Clear authentication data
export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('user');
  // Also clear old authToken if it exists
  localStorage.removeItem('authToken');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = getToken();
  const user = getStoredUser();
  return !!(token && user);
};

// Validate token format (basic check)
export const isValidTokenFormat = (token) => {
  if (!token || typeof token !== 'string') return false;
  // Basic JWT format check (3 parts separated by dots)
  const parts = token.split('.');
  return parts.length === 3;
};

// Get user role(s)
export const getUserRoles = () => {
  const user = getStoredUser();
  if (!user) return [];
  
  // Handle both single role and multiple roles
  if (user.roles && Array.isArray(user.roles)) {
    return user.roles;
  }
  if (user.role) {
    return [user.role];
  }
  return [];
};

// Check if user has specific role
export const hasRole = (requiredRole) => {
  const roles = getUserRoles();
  return roles.includes(requiredRole);
};

// Get primary user role
export const getPrimaryRole = () => {
  const user = getStoredUser();
  if (!user) return null;
  
  return user.primaryRole || user.role || (user.roles && user.roles[0]) || null;
};